import { KoncentroBaseModel } from './koncentro-base.model';

export class CalendarGroup extends KoncentroBaseModel {
  public dto ?= 'CalendarGroupDto';

  public id?: number;
  public code: string;
  public description: string;
}

export class CalendarGroupStoreModel extends KoncentroBaseModel {
  public dto ?= 'CalendarGroupStoreDto';

  public id?: number;
  public store_id: number;
  public calendar_group_id: number;
  public start_date: string;
}

export class CalendarGroupStoreList extends KoncentroBaseModel {
  public dto ?= 'CalendarGroupStoreListDto';

  public id: number;
  public storeId: number;
  public calendarGroupId: number;
  public startDate: string;
  public calendarGroupCode: string;
  public calendarGroupDescription: string;
}



// WEBPACK FOOTER //
// ./src/app/models/calendar-group.model.ts